import { Card } from 'components/shadcn/card';
import { Conversation } from 'components';
import { UpdateChatForm } from 'pages/dashboard';

export const EditChat = () => {
  return (
    <div className="w-full p-8">
      <div className="flex gap-4 w-full">
        <div className="flex-1 min-w-0 w-2/3">
          <UpdateChatForm />
        </div>
        <div className="w-1/3">
          <Card className="rounded-xl sticky top-8 max-h-[calc(100vh-64px)] h-full overflow-y-auto border border-border">
            <Conversation playgroundMode />
          </Card>
        </div>
      </div>
    </div>
  );
};
